import { loadPyodide, type PyodideInterface } from "pyodide";

let pyodideInstance: PyodideInterface | null = null;
let loadingPromise: Promise<PyodideInterface> | null = null;

export async function getPyodide(): Promise<PyodideInterface> {
  if (pyodideInstance) {
    return pyodideInstance;
  }

  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = loadPyodide({
    indexURL: "https://cdn.jsdelivr.net/pyodide/v0.26.4/full/",
  }).then((pyodide) => {
    pyodideInstance = pyodide;
    // Load numpy by default for ML challenges
    return pyodide.loadPackage("numpy").then(() => pyodide);
  });

  return loadingPromise;
}

export function isPyodideLoaded(): boolean {
  return pyodideInstance !== null;
}
